module.exports = __webpack_public_path__ + "img/pro_seven_4.eb307b1d.jpg";